import { createContext, useContext, useEffect, useState } from "react";

// @ts-ignore
const ThemeContext = createContext();

// @ts-ignore
export const ThemeProvider = ({ children }) => {
    const brand = import.meta.env.VITE_VMS_APP_NAME || "FTF"; // Valeur par défaut
    // @ts-ignore
    const [theme, setTheme] = useState(brand);

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
